import React from 'react';
import { AdditionalInputValueChangingButtons } from '@pascal/pascal-core/shared/core/enums/additionalInputValueChangingButtons';
import { globalTranslationKeys } from '../../../../../../enums';

const AdditionalButtons = ({
  t,
  limits,
  betAmount,
  // changeBetAmount,
  // decidedCallBackCall,
  handleChangeInputValue,
}) => {
  const { minBet, maxBet } = limits;
  const isDisabledMinButton = Number(betAmount) === minBet ? 'passive' : '';
  const isDisabledMaxButton = Number(betAmount) === maxBet ? 'passive' : '';
  return (
    <div className='b-s-small-btn-ins'>
      <div
        className={`b-s-small-btn-clm ${isDisabledMinButton}`}
        title={t(globalTranslationKeys.Min)}
        onClick={() => {
          handleChangeInputValue(AdditionalInputValueChangingButtons.min);
          // decidedCallBackCall(() => changeBetAmount(additionalBetAmountChangingButtons.min), true);
        }}
      >
        <div className='b-s-small-btn-block'>
          <span className='b-s-small-btn-txt'>{t(globalTranslationKeys.Min)}</span>
        </div>
      </div>
      <div
        className='b-s-small-btn-clm'
        title='1/2'
        onClick={() => {
          handleChangeInputValue(AdditionalInputValueChangingButtons.divide);
          // decidedCallBackCall(
          //   () => changeBetAmount(additionalBetAmountChangingButtons.divide),
          //   true
          // );
        }}
      >
        <div className='b-s-small-btn-block'>
          <span className='b-s-small-btn-txt'>1/2</span>
        </div>
      </div>
      <div
        className='b-s-small-btn-clm'
        title='x2'
        onClick={() => {
          handleChangeInputValue(AdditionalInputValueChangingButtons.multiply);
          // decidedCallBackCall(
          //   () => changeBetAmount(additionalBetAmountChangingButtons.double),
          //   true
          // );
        }}
      >
        {/* add class active */}
        <div className='b-s-small-btn-block'>
          <span className='b-s-small-btn-txt'>x2</span>
        </div>
      </div>
      <div
        className={`b-s-small-btn-clm ${isDisabledMaxButton}`}
        title={t(globalTranslationKeys.Max)}
        onClick={() => {
          handleChangeInputValue(AdditionalInputValueChangingButtons.max);
          // decidedCallBackCall(() => changeBetAmount(additionalBetAmountChangingButtons.max), true);
        }}
      >
        <div className='b-s-small-btn-block'>
          <span className='b-s-small-btn-txt'>{t(globalTranslationKeys.Max)}</span>
        </div>
      </div>
    </div>
  );
};

export default AdditionalButtons;
